import {Cureus} from '../Cureus';

Cureus.AdminArticleAvailableReviewers = {};

//= require_tree ./AdminArticleAvailableReviewers